// @flow

import * as React from 'react';
import Button from '@ta/styleguide.button';
import { localize } from '@ta/common.i18n';
import { Opener, Local } from '@ta/overlays.managers';
import styles from './LoadingErrorBanner.less';

type Props = {|
  refetch?: () => mixed,
|};

type RendererProps = {|
  /** Function that accepts a `renderErrorBanner` param and returns a child node to render. */
  children: (renderErrorBanner: () => void) => React.Node,
|};

const name = '__ERROR__';
/** Component to render the error banner */
export const RenderErrorBanner = ({ children }: RendererProps) => (
  <Opener name={name} local>
    {children}
  </Opener>
);

const LoadingErrorBanner = ({ refetch }: Props) => (
  <Local name={name}>
    <div className={`${styles.error_block} ui_card`}>
      <div className={styles.error_heading}>
        {localize('social_loading_error_1')} {/* Whoops, something went wrong. */}
        {localize('soical_loading_error_2')} {/* Give it another try please */}
      </div>
      <Button
        onClick={() => {
          // Need to define a wrapper call, otherwise onClick will pass its own args!
          /* istanbul ignore else */
          if (refetch) {
            refetch();
          }
        }}
        type="primary"
        size="default"
      >
        {localize('mobile_try_again')} {/* Try again */}
      </Button>
    </div>
  </Local>
);
LoadingErrorBanner.defaultProps = {
  refetch: () => {
    /* istanbul ignore next */
    // eslint-disable-next-line no-restricted-globals
    window.location.reload();
  },
};

export default LoadingErrorBanner;
